export default __webpack_public_path__ + "static/media/icon-descuentos.fe5038f2.svg";